import React from 'react'
import BottomSheetContent from '../BottomSheetComponents/BottomSheetContent'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'

interface PlanDetailsBottomSheetProps {
    onDismiss: () => void
    ScreenName: string
}

export const PlanDetailsBottomSheet: React.FC<PlanDetailsBottomSheetProps> = ({
    onDismiss,
    ScreenName
}) => {
    const handleClose = () => {
        trackEvent({
            eventName: EventNames.UserClicked,
            payload: {
                eventId: 'PlanDetailsBottomSheet',
                responseName: 'Close',
                screenType: ScreenName,
            }
        })
        onDismiss()
    }

    return (
        <BottomSheetContent
            heading="We only recommend a switch when it can meaningfully improve your portfolio returns. "
            onDismiss={handleClose}
            bottomSheetBodyClassName="!px-0"
            logoSrc="/images/power-rebalance/manual-book.png"
            bottomSheetHeadingClassName="!font-normal"
        >
            <div className='text-grey40 text-13 px-5'>
                Here's when we may not recommend a switch:
                <br /> <br/>
                <ul className='list-disc pl-3'>
                    <li><span className='text-black'>Recent investment (&lt;1 yr):</span> Not enough data yet to give a reliable switch recommendation</li>
                    <li><span className='text-black'>Unrated funds:</span> Within equity funds, we don't rate New funds &lt; 2years old OR Categories with less(&lt;5) peers. Other funds like Hybrid, Debt etc will be rated soon</li>
                    <li><span className='text-black'>Fund is doing well:</span> If a fund is compounding well, we want that to continue without interruption</li>
                    <li><span className='text-black'>Tax + exit load impact:</span> Switch is avoided if tax + exit load costs outweigh benefit</li>
                    <li><span className='text-black'>ELSS lock-in:</span> No switches recommended until at least 10% of units are free from lock-in</li>
                    <li><span className='text-black'>Index funds:</span> Currently excluded since we prioritise bigger impact opportunities</li>
                </ul>
            </div>
        </BottomSheetContent>
    )
}
